/*
    Allow to type only numbers
*/
import { Directive, HostListener, OnInit, Input, ElementRef } from '@angular/core';
import * as Utils from '../../utils';

@Directive({
    selector: '[directive-numbers-only]', /* [directive="numberOnly"] */
})
export class InputNumberOnlyDirective implements OnInit {
    @Input() public numbersOnlyDisabled: boolean = false;
    @Input() public floats: boolean = true;

    constructor(
        private _elementRef: ElementRef,
    ) { }

    ngOnInit() {
    }

    @HostListener('keydown', ['$event']) public onKeyDown(e: KeyboardEvent): void {
        if (this.numbersOnlyDisabled) return;

        /* Prevent dots */
        if (e.keyCode === 190 && this.floats === false) {
            e.preventDefault();
            return;
        }

        if (Utils.Inputs.isKeySafe(e)) return;

        /* Ensure that it is a number and stop the keypress */
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    }
}
